import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "Trading Lottery",
          "Lumina Rewards",
          "Lumeria Metaverse",
          "Virtual Enterprenuers",
          "Earn from Projects",
          "Governers of Cerulean DAO",
          "Passive Income"
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;
